import { render, staticRenderFns } from "./AlipayIdentityInfoPage.vue?vue&type=template&id=710f4cd4&scoped=true"
import script from "./AlipayIdentityInfoPage.vue?vue&type=script&lang=js"
export * from "./AlipayIdentityInfoPage.vue?vue&type=script&lang=js"
import style0 from "./AlipayIdentityInfoPage.vue?vue&type=style&index=0&id=710f4cd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710f4cd4",
  null
  
)

export default component.exports